import { useImmer } from "use-immer";
import { useEffect } from "react";
import UtilService from "../../service/UtilService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";

const Component = ({ config, onChange }) => {
  const [data, updateData] = useImmer(config);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const getKillSwitchTimeRemainingMinutes = () => {
    return UtilService.mapIsoOffsetDateTimeStringToMinutesRemaining(
      data.activatedTo,
    );
  };

  const isKillSwitchActive = () => {
    return getKillSwitchTimeRemainingMinutes() > 0;
  };

  const changeKillSwitchActive = () => {
    const isActive = isKillSwitchActive();
    if (isActive) {
      deactivateKillSwitch();
    } else {
      activateKillSwitch();
    }
  };

  const activateKillSwitch = () => {
    const result = prompt(
      "You are going to deactivate entire WAG Card Lock system. This means that all Transactions with Card Lock will be approved by WAG despite the card has been not unlocked by the Customer. \n\nIf you want to continue then type YES and then Save the config:",
    );
    if (result.toLowerCase() !== "yes") {
      return;
    }
    updateData((d) => {
      d.activatedTo = UtilService.mapMinutesRemainingToIsoOffsetDateTimeString(
        data.activationDurationMinutes,
      );
    });
  };

  const deactivateKillSwitch = () => {
    const ok = window.confirm(
      "You are going to again activate entire WAG Card Lock system. Don't forget to Save config.",
    );
    if (!ok) {
      return;
    }
    updateData((d) => {
      d.activatedTo = null;
    });
  };

  const prolongActivation = () => {
    const currentReaminingMinutes =
      UtilService.mapIsoOffsetDateTimeStringToMinutesRemaining(
        data.activatedTo,
      );
    const newRemainingMinutes =
      currentReaminingMinutes + data.activationDurationMinutes;
    const activatedTo =
      UtilService.mapMinutesRemainingToIsoOffsetDateTimeString(
        newRemainingMinutes,
      );

    const ok = window.confirm(
      "You are going to prolong activation until " +
        UtilService.isoDateToReadable(activatedTo) +
        ". Don't forget to Save config.",
    );
    if (!ok) {
      return;
    }

    updateData((d) => {
      d.activatedTo = activatedTo;
    });
  };

  const changeTimeRemaining = (value) => {
    if (!value) {
      value = 0;
    }

    console.log(value);

    // Set boundaries

    let val = Number(value);
    val = val > 180 ? 180 : val;
    val = val <= 1 ? 1 : val;

    console.log(val);

    updateData((d) => {
      d.activatedTo =
        UtilService.mapMinutesRemainingToIsoOffsetDateTimeString(val);
    });
  };

  return (
    <>
      {data && (
        <table className="config-table">
          <thead>
            <tr>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr className={isKillSwitchActive() ? "warn" : ""}>
              <td>Status</td>
              <td>
                <input
                  type="checkbox"
                  checked={isKillSwitchActive()}
                  onChange={(e) => changeKillSwitchActive()}
                />
                &nbsp;
                {isKillSwitchActive() ? (
                  <>
                    Kill switch is active{" "}
                    <FontAwesomeIcon
                      icon={faTriangleExclamation}
                      className="fa-fade"
                    />
                  </>
                ) : (
                  "Inactive"
                )}
              </td>
            </tr>
            {isKillSwitchActive() && (
              <>
                <tr className="warn">
                  <td>
                    Active until <small>[CET]</small>
                  </td>
                  <td>{UtilService.isoDateToReadable(data.activatedTo)}</td>
                </tr>
                <tr className="warn">
                  <td>
                    Time remaining <small>[minutes]</small>
                  </td>
                  <td>{getKillSwitchTimeRemainingMinutes()}</td>
                </tr>
                <tr className="warn">
                  <td>Action</td>
                  <td>
                    <a onClick={(e) => prolongActivation()}>
                      Prolong activation
                    </a>
                  </td>
                </tr>
              </>
            )}
            <tr>
              <td>Different locations count min.</td>
              <td>
                <input
                  type="number"
                  value={data.differentLocationsCountMin}
                  onChange={(e) =>
                    updateData((d) => {
                      let val = e.target.value;
                      val = val > 100 ? 100 : val;
                      val = val < 10 ? 10 : val;
                      d.differentLocationsCountMin = val;
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                Activation duration <small>[minutes]</small>{" "}
              </td>
              <td>
                <input
                  type="number"
                  value={data.activationDurationMinutes}
                  onChange={(e) =>
                    updateData((d) => {
                      let val = e.target.value;
                      val = val > 180 ? 180 : val;
                      val = val < 5 ? 5 : val;
                      d.activationDurationMinutes = val;
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                Auto-on interval <small>[minutes]</small>{" "}
              </td>
              <td>
                <input
                  type="number"
                  value={data.autoTurnOnTimeIntervalMinutes}
                  onChange={(e) =>
                    updateData((d) => {
                      let val = e.target.value;
                      val = val > 180 ? 180 : val;
                      val = val < 30 ? 30 : val;
                      d.autoTurnOnTimeIntervalMinutes = val;
                    })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                Auto-on declined <small>[%]</small>
              </td>
              <td>
                <input
                  type="number"
                  step={0.01}
                  value={data.autoTurnOnDeclinedTransactionThresholdRatio * 100}
                  onChange={(e) =>
                    updateData((d) => {
                      let val = e.target.value / 100;
                      val = val > 0.015 ? 0.015 : val;
                      val = val < 0.002 ? 0.002 : val;
                      d.autoTurnOnDeclinedTransactionThresholdRatio = val;
                    })
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </>
  );
};

export default Component;
